<!-- 手卫生上报活动开始之前展示页面 -->
<template>
  <div class='handMonitorRrported'>
    <v-header id='header' v-if='$route.query.source==0' @back='handleShowBack' :rightTitle='rightTitle' v-on:rightClick='rightClick' :headTitle='headTitle' :goApp='true' :isBack='true' :pageName="pageName"></v-header>
    <div
      class="container"
      id='container'
    >
      <div class="banner">
        <img
          src="../../assets/images/fixed-banner.png"
          alt=""
        >
      </div>
      <div class="tab-content">
        <van-tabs
          v-model="tabIndex"
          :offset-top="utils.isIphoneX()&&$route.query.source==0?85:$route.query.source==0?65:0"
          scrollspy
          sticky
          color='#26B4FF'
          :ellipsis="false"
          title-active-color='#26B4FF'
          title-inactive-color='#333'
          @scroll='handleScroll'
          @change='handleChangeTab'
        >
          <van-tab
            title="介绍"
            title-style='font-size:16px;'
          >
            <div
              class="introduce"
              id='introduce'
            >
              <div class="video-box">
                <video v-if='vedioUrl' crossorigin="anonymous" poster='../../assets/images/jcfajd1.png' id='videoPlay' x5-video-player-type='h5-page' controlslist="nodownload" :src="vedioUrl" controls ></video>
                <!-- <img
                  src="../../assets/images/jcfajd.png"
                  alt=""
                > -->
                <p>（监测方案解读）</p>
              </div>
              <div class="activity-background">
                <div class="item-title df-item-center">
                  活动背景
                </div>
                <div class="item-content">
                  <div class="content-title"> 主办方: </div>
                  <p>全国医院感染监控管理培训基地 、全国医院感染监测网</p>
                </div>
                <div class="item-content">
                  <div class="content-title"> 目的： </div>
                  <p>每隔两年进行1次，目的是了解医务人员手卫生现状及有关医院感染指标，评价手卫生与医院感染相关指标的关系，进一步促进手卫生措施的落实。</p>
                </div>
                <div
                  class="notice-file df-center"
                  @click='goPdfPreview'
                >
                  <span>点击查看官方通知文件</span>
                  <img
                    src="../../assets/images/report-arrowRight.png"
                    alt=""
                  >
                </div>
              </div>
              <div class="earnings">
                <div class="item-title df-item-center">
                  可获收益
                </div>
                <div class="earnings-heed">
                  <div class='df-center'>
                    <img
                      src="../../assets/images/report-tisheng.png"
                      alt=""
                    >
                    <h3>获得专业提升</h3>
                  </div>
                  <p>规范感控专兼职人员手卫生监测方法，促进本院医务人员手卫生依从率、正确率、知晓率提升</p>
                </div>
                <div class="earnings-content df-between">
                  <div
                    class='earnings-left'
                    style='margin-right:10px'
                  >
                    <h3 style='margin-bottom:10px;'>免费学习</h3>
                    <p>中国医务人员诊疗过程手卫生执行示范情景剧系列</p>
                  </div>
                  <div class='earnings-right'>
                    <img
                      src="../../assets/images/mfxx.png"
                      alt=""
                    >
                  </div>
                </div>

                <div class="earnings-content df-between">
                  <div
                    class='earnings-right'
                    style='margin-right:10px'
                  >
                    <img
                      src="../../assets/images/zngc.png"
                      alt=""
                    >
                  </div>
                  <div class='earnings-left'>
                    <h3 style='margin-bottom:10px;text-align:right;'>智能观察</h3>
                    <p class='p-right'>利用手机等移动设备即可录入观察数据/上传现场拍照/记录问题等实现移动智能查检在线</p>
                  </div>
                </div>

                <div
                  class="earnings-content df-between"
                  style='margin-bottom:20px;'
                >
                  <div
                    class='earnings-left'
                    style='margin-right:10px'
                  >
                    <h3 style='margin-bottom:10px;'>授权证书</h3>
                    <p>完成学习并考试合格，可获得电子证书“手卫生执行知识合格证”</p>
                  </div>
                  <div class='earnings-right'>
                    <img
                      src="../../assets/images/sqzs.png"
                      alt=""
                    >
                  </div>
                </div>
                <div class="earnings-heed">
                  <div class='df-center'>
                    <img
                      src="../../assets/images/repotr-tongji.png"
                      alt=""
                    >
                    <h3>获得专业报告</h3>
                  </div>
                  <p>可自动获得本次监测上报的各类数据统计</p>
                </div>
                <ul class='list-content'>
                  <li class='df-item-center'>全员手卫生知识知晓率情况</li>
                  <li class='df-item-center'>调查科室手卫生依从及正确情况</li>
                  <li class='df-item-center'>调查科室手卫生用品消耗情况</li>
                  <li class='df-item-center'>重点质控指标情况</li>
                </ul>
              </div>
              <div class="data-safety">
                <div class="item-title df-item-center">
                  数据安全
                </div>
                <div class="data-safety-content">
                  <p style='margin-bottom:20px;'>医疗机构上报的数据在评定有效之后将会纳入全国统计分析样本，分析统计数据趋势，不会关注及披露医疗机构个体数据，保持数据真实有效即可。</p>
                  <p>同时，本次上报技术和服务由获得“国家信息安全三级等保认证”（由公安部颁发，非银行机构最高安全认证）的感控工作间支持，保证数据安全。</p>
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab
            title="流程"
            title-style='font-size:16px;'
          >
            <div
              class="tab-flow"
              id='tabFlow'
            >
              <div
                class="template-download df-center"
                v-if='$route.query.source==0'
              >
                <span>院内监测工作方案模版</span>
                <span
                  class='download'
                  @click='handleDownTemplate'
                >下载</span>
              </div>
              <div
                class="flow-item"
                v-for='(item,index) in flowData'
                :key='index'
              >
                <div class="flow-title df-item-center">
                  <span class='df-center'>{{index+1}}</span>
                  <h3>{{item.title}}</h3>
                </div>
                <div class="flow-content-box">
                  <div class='flow-content'>
                    <div
                      :class="{'flow-content-item-time':index<3}"
                      style='display:flex;'
                    >
                      <img
                        src="../../assets/images/report-shijin.png"
                        alt=""
                      >
                      <p>{{item.children[0].text}}</p>
                    </div>
                    <div
                      class='flow-content-item'
                      v-if='idx>0'
                      v-for='(d,idx) in item.children'
                      :key='idx'
                    >
                      <div class='dot'></div>
                      <p>{{d.text}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
          <!-- <van-tab title="推荐" title-style='font-size:16px;'>
            <div class="recommend" id='recommend' @click='handleToKnowledgeMeasurement'>
              <img src="../../assets/images/fixed-banner.png" alt="" >
            </div>
          </van-tab> -->
        </van-tabs>
      </div>

      <van-popup
        v-model="isShowPopup"
        style='border-radius:10px;'
      >
        <div class="dalog-box">
          <div class="dalog-content">
            <div class="dalog-title">{{dalogTitle}}</div>
            <p :style="{'text-align':$route.query.source==0?'':'center'}">{{dalogContent}}</p>
          </div>
          <div class="line"></div>
          <div class="btn-box df-between">
            <div
              class="btn btn-gray df-center"
              @click='handleBtnLeft'
            >{{dalogBtn1}}</div>
            <div
              class="btn df-center"
              @click='handleBtnRight'
            >{{dalogBtn2}}</div>
          </div>
          <div
            class="close-dalog"
            @click='handleClosePopup'
          >
            <i class="iconfont icon-close"></i>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="isShowRoleSelect&&$route.query.source==0" style='border-radius:10px;' >
        <!-- <roleSelect :postId='_userInfo.data.postId' :userPost='userPost' v-on:conFirmRole='conFirmRole' ></roleSelect> -->
        <roleSelect :postId='_userInfo.data&&_userInfo.data.postId?_userInfo.data.postId:""' :userPost='userPost' v-on:conFirmRole='conFirmRole'></roleSelect>
      </van-popup>
    </div>
    <div class="footer df-between">
      <div
        class="btn df-center progressAndStatistics"
        @click='checkProgress'
      >
        区域上报进度及统计
      </div>
      <div
        class="btn df-center join-reported"
        @click='handleJoinReported'
      >进入上报</div>
    </div>

  </div>
</template>

<script>
  import header from '../../components/header/header'
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import roleSelect from './roleSelect.vue'
  import { Toast } from 'vant'

  Vue.use(Toast)
  export default {
    data() {
      return {
        vedioUrl:'https://video.gkgzj.com/d34254c48e694dc2b5b5f5b9b40c9404/93834ea1f30b4906bebe30eb5dc507de-7509dcebf99a2f53fb7c0ba12edac39c-ld.mp4',
        sponsor: '',
        userPost: '', //  手卫生角色 1 手卫生观察员  2其他数据监测员  3其他医务人员
        isFixed: false, // 是否吸顶
        isManagerUser: '', // 1 管理员权限
        isAuth: '', // 7 未激活 6 修改后待审核 5被邀请 4 使用中 3 审核拒绝 2 已提交认证，待审核 1 审核通过 0已激活，未提交审核
        noticeUrl:
          'https://dygk.gkgzj.com/incontrol-fileserver/file/pic/fff2a272-1a37-4073-86cd-a5ac0d274cf4',
        isShowPopup: false,
        isShowRoleSelect: false,
        headTitle: '',
        rightTitle: '分享',
        pageName: 'handMonitorRrported',
        tabIndex: 0,
        dalogTitle: '',
        dalogContent: '',
        dalogBtn1: '',
        dalogBtn2: '',
        userStatusTips: [
          {
            dalogTitle: '您当前处在体验医院',
            dalogContent: '请先前往我的医院加入到正确的医院后在进行相应操作',
            dalogBtn1: '',
            dalogBtn2: '去加入医院',
          },
          {
            dalogTitle: '审核认证中',
            dalogContent:
              '您的认证资料已提交，待管理员XXX审核，如有问题，可拨打平台电话400-969-7756',
            dalogBtn1: '重新编辑',
            dalogBtn2: '通知管理员',
          },
          {
            dalogTitle: '审核认证中',
            dalogContent:
              '您已申请加入【XX医院】，资料正在审核中，请联系客服尽快处理',
            dalogBtn1: '修改资料',
            dalogBtn2: '联系客服',
          },
          {
            dalogTitle: '提示',
            dalogContent: '需登录【感控工作间APP】操作',
            dalogBtn1: '取消',
            dalogBtn2: '打开APP',
          },
        ],
        listData: [],
        flowData: [
          {
            number: 1,
            title: '完成前期准备工作',
            children: [
              {
                id: 1,
                text: '在进行预监测之前完成',
              },
              {
                id: 2,
                text: '检查并补充单位信息',
              },
              {
                id: 3,
                text: '确定上报科室',
              },
              {
                id: 4,
                text: '邀请成员注册并审核',
              },
            ],
          },
          {
            number: 2,
            title: '完成手卫生依从监测',
            children: [
              {
                id: 1,
                text: '2021年9月1日前预监测，9月1日-9月31日正式监测',
              },
              {
                id: 2,
                text: '完成手卫生观察员培训与考核',
              },
              {
                id: 3,
                text: '完成指定监测对象的手卫生观察',
              },
            ],
          },
          {
            number: 3,
            title: '完成其他数据监测',
            children: [
              {
                id: 1,
                text: '2021年10月1日-10月31日进行上报',
              },
              {
                id: 2,
                text: '提交2020年部分质量控制指标',
              },
              {
                id: 3,
                text: '提交2021年9月手卫生用品消耗量情况',
              },
            ],
          },
          {
            number: 4,
            title: '最后由感控科主任审核后确定上报',
            children: [
              {
                id: 1,
                text: '2021年10月1日之后',
              },
            ],
          },
        ],
      }
    },
    components: {
      'v-header': header,
      roleSelect,
    },
    computed: {
      ...mapState({
        _userInfo: (state) => state.InvestorInfo,
        baseUrl: (state) => state._base,
        _studyExamBase: (state) => state._studyExamBase,
      }),
    },
    created() {
      localStorage.setItem('taskId', this.$route.query.taskId)
      localStorage.setItem('batch', this.$route.query.batch)
      // if(this.$route.query.source==0){
      //   this.initUserHandActivityInfo()
      // }
      // this.initData()
      // this.initTaskDetailData()
    },
    mounted() {},
    watch: {},
    methods: {
      rightClick() {
        let url = `${this.baseUrl}/handMonitorReported/#/handMonitorRrported?taskId=1&batch=2021`
        // let url = 'http://192.168.1.21:8088/#/handMonitorRrported?taskId=1&batch=2021'
        let title = '邀请您参与2021年全国医务人员诊疗过程手卫生监测'
        let content = '点击了解详情'
        try {
          uni.postMessage({
            data: {
              action: 'showShareView',
              data: {
                shareUrl: url,
                shareTitle: title,
                shareContent: content,
              }
            }
          });
          window.webkit.messageHandlers.showShareView.postMessage({
            shareUrl: url,
            shareTitle: title,
            shareContent: content,
          })
        } catch (err) {
          window.gk.showShareView(url, title, content)
        }
        console.log('点击勒分享')
      },
      initTaskDetailData() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskId: this.$route.query.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.getTaskDetailById(params).then((res) => {
          if (res.code === 0) {
            this.sponsor = res.data.hospName
            this.headTitle = res.data.taskName
            this.noticeUrl = res.data.notices
            localStorage.setItem('taskName', res.data.taskName)
          } else {
            this.$toast(res.msg)
          }
        })
      },
      initData() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskId: this.$route.query.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingTaskLinkInfo(params).then((res) => {
          if (res.code === 0) {
            this.listData = res.data
            let stepThreeBeginTime =
              res.data[2].beginTime.substring(0, 4) +
              '年' +
              res.data[2].beginTime.substring(5, 7) +
              '月' +
              res.data[2].beginTime.substring(8, 10) +
              '日'
            this.listData.forEach((v, i) => {
              this.$set(v, 'isShowContent', false)
              this.$set(v, 'children', [])
              this.initChildRenData(v, i)
            })
            this.listData.push({
              linkName: '最后由感控科主任审核后确定上报',
              describes: stepThreeBeginTime + '之后',
            })
          } else {
            this.$toast(res.msg)
          }
        })
      },
      initChildRenData(val, index) {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            taskLinkId: val.id,
            batch: this.$route.query.batch,
          },
          malVersion: 'A0',
        }
        this.$http.getReportingTaskIndex(params).then((res) => {
          if (res.code === 0) {
            res.data.forEach((v, i) => {
              if (index == 1) {
                v.indexName = '完成' + v.indexName
              } else if (index == 2) {
                v.indexName = '提交' + v.indexName
              }
            })
            val.children = res.data
          }
        })
        console.log(this.listData, 'listData')
      },
      // 获取用户手卫生活动的用户信息
      initUserHandActivityInfo() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            handTaskId: this.$route.query.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.getUserHandActivityInfo(params).then((res) => {
          if (res.code === 0) {
            this.isManagerUser = res.data.isManagerUser
            this.isAuth = res.data.isAuth
            this.userPost = res.data.userPost
            localStorage.setItem('isManagerUser', this.isManagerUser)
            localStorage.setItem('isAuth', this.isAuth)
            if (res.data.hasInit == 0) {
              this.initActivityData()
            }
          } else {
            this.$toast(res.msg)
          }
        })
      },
      // 点击开始上报初始化数据(永远只调一次)
      initActivityData() {
        let params = {
          userId: this._userInfo.data.userId,
          sub_id: '',
          comId: this._userInfo.data.comId,
          data: {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            taskId: this.$route.query.taskId,
          },
          malVersion: 'A0',
        }
        this.$http.initActivityData(params).then((res) => {
          if (res.code === 0) {
          } else {
            this.$toast(res.msg)
          }
        })
      },
      // 下载模板
      handleDownTemplate() {
        try {
          uni.postMessage({
            data: {
              action: 'downLoad',
              data: {
                url: 'https://dygk.gkgzj.com/group1/M00/17/9B/rBEQgGD30ZaAHFT2AAA-2hptLZM91.docx',
                reportId: '',
                rptTitleAlias: '院内监测工作方案模版',
                isDesensitization: '',
              }
            }
          });
          window.webkit.messageHandlers.downLoad.postMessage({
            url: 'https://dygk.gkgzj.com/group1/M00/17/9B/rBEQgGD30ZaAHFT2AAA-2hptLZM91.docx',
            reportId: '',
            rptTitleAlias: '院内监测工作方案模版',
            isDesensitization: '',
          })
        } catch (err) {
          window.gk.downLoad(
            'https://dygk.gkgzj.com/group1/M00/17/9B/rBEQgGD30ZaAHFT2AAA-2hptLZM91.docx',
            '',
            '院内监测工作方案模版'
          )
        }
      },
      // 查看通知文件
      goPdfPreview() {
        this.$router.push({
          path: '/pdfPreview',
          query: {
            url: this.noticeUrl,
            isShowPdfHead: '0',
          },
        })
      },
      handleShowBack() {
        this.utils.goAppBack()
      },
      handleScroll(val) {
        this.isFixed = val.isFixed
      },
      handleChangeTab() {
        let a = document.getElementById('introduce')
        let b = document.getElementById('tabFlow')
        if (this.tabIndex == 2) {
          a.style.display = 'none'
          b.style.display = 'none'
          // window.scrollTo(-100,-500);
          // document.getElementById('container').scrollTop = 200
        } else {
          a.style.display = 'block'
          b.style.display = 'block'
        }
      },
      handleClosePopup() {
        this.isShowPopup = false
      },
      // 区域上报进度及统计
      checkProgress() {
        Toast('还未开始，将在2021年8月中旬开放进行预监测')
        return
        if (this.$route.query.source == 0) {
          // 跳转到上报进度及统计页
          this.$router.push({
            path: '/areaRptIndexParent',
          })
        } else {
          this.handleJump()
        }
      },
      handleJump() {
        this.dalogTitle = this.userStatusTips[3].dalogTitle
        this.dalogContent = this.userStatusTips[3].dalogContent
        this.dalogBtn1 = this.userStatusTips[3].dalogBtn1
        this.dalogBtn2 = this.userStatusTips[3].dalogBtn2
        this.isShowPopup = true
      },
      // 进入上报
      handleJoinReported() {
        Toast('还未开始，将在2021年8月中旬开放进行预监测')
        return
        console.log(this.userPost, 'this.userPost')
        if (this.$route.query.source == 0) {
          let _this = this
          console.log('在app内')
          try {
            window.jumpToMonitorRptIndex = function (data) {
              if (
                _this._userInfo.data.postId == 1 ||
                _this._userInfo.data.postId == 2
              ) {
                if (_this.userPost && _this.userPost != '3') {
                  localStorage.setItem('roleCode', _this.userPost)
                  _this.$router.push({
                    path: '/monitorRptIndexParent',
                  })
                } else {
                  _this.isShowRoleSelect = true
                }
              } else {
                if (_this.userPost && _this.userPost != '2') {
                  // 感控科主任选择手卫生角色为 其他数据检测员（‘2’）后修改角色为兼职时手卫生角色不会清除
                  localStorage.setItem('roleCode', _this.userPost)
                  _this.$router.push({
                    path: '/monitorRptIndexParent',
                  })
                } else {
                  _this.isShowRoleSelect = true
                }
              }
              // _this.isShowRoleSelect = true
            }
          } catch (err) {}
          try {
            uni.postMessage({
              data: {
                action: 'showIsAuth',
                data: 'jumpToMonitorRptIndex'
              }
            });
            window.webkit.messageHandlers.showIsAuth.postMessage(
              'jumpToMonitorRptIndex'
            )
          } catch (err) {
            window.gk.showIsAuth('jumpToMonitorRptIndex')
          }
        } else {
          // this.isShowRoleSelect = true
          this.handleJump()
        }
      },
      // 确定角色
      conFirmRole(val) {
        if (val.length > 0) {
          this.isShowRoleSelect = false
          localStorage.setItem('roleCode', val.join())
          let params = {
            comId: this._userInfo.data.comId,
            userId: this._userInfo.data.userId,
            data: {
              comId: this._userInfo.data.comId,
              taskId: this.$route.query.taskId,
              userPost: val.join(), // 1-手卫生观察员，2-其他数据检测员 3-其他医务人员
              userName: this._userInfo.data.cnName?this._userInfo.data.cnName:this._userInfo.data.userName,
              userId: this._userInfo.data.userId,
            },
          }
          this.$http.updateSwsReportingUser(params).then((res) => {
            if (res.code === 0) {
              this.$router.push({
                path: '/monitorRptIndexParent',
              })
            } else {
              this.$toast(res.msg)
            }
          })
        } else {
          Toast('请先选择角色')
        }
      },
      // 弹窗左侧按钮
      handleBtnLeft() {
        if (this.$route.query.source != 0) {
          this.isShowPopup = false
        }
      },
      // 弹窗右侧按钮
      handleBtnRight() {
        if (this.$route.query.source != 0) {
          this.goDownApp()
          // this.$router.push({ path: "/openApp" });
        }
      },
      // 跳转到手卫生观察员培训与测评
      handleToKnowledgeMeasurement() {
        if (this.$route.query.source == 0) {
          if (this.isAuth == 1) {
            let path = `${this._studyExamBase}/manager-intf/?#/knowledgeMeasurement?userId=${this._userInfo.data.userId}&source=0`
            console.log(path, '去学习考试路径')
            location.href = path
          } else {
            this.$toast('需等您提交的个人信息审核通过之后才能进行操作')
          }
          // this.$router.push({
          //   path: "/knowledgeMeasurement",
          //   query: {
          //     titleName: '手卫生观察员培训与测评',
          //     taskId:this.$route.query.taskId
          //   },
          // });
        } else {
          this.handleJump()
        }
      },
    },
  }
</script>
<style lang='scss' scoped>
  .handMonitorRrported {
    display: flex;
    flex-direction: column;
    height: 100vh;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #333;
    .container {
      overflow: scroll;
      height: 100vh;
      .banner {
        height: 160px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .tab-content {
        border-radius: 10px 10px 0 0;
        margin-top: -15px;
        overflow: hidden;
      }
      .introduce {
        padding-top: 25px;
        .video-box {
          padding: 15px 15px 11px 15px;
          width: 96%;
          margin: 0 auto;
          margin-bottom: 15px;
          background: #f7f8fa;
          border-radius: 10px;
          video {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
          }
          p {
            margin-top: 15px;
            text-align: center;
          }
        }
        .item-title {
          &:before {
            margin-right: 5px;
            content: '';
            display: inline-block;
            width: 4px;
            height: 18px;
            background: #26b4ff;
            border-radius: 2px;
          }
        }
        .activity-background {
          padding: 15px 12px;
          background: #f1f5ff;
          .item-content {
            margin-top: 10px;
            padding: 12px;
            background: #ffffff;
            border-radius: 5px;
            .content-title {
              margin-bottom: 10px;
              font-size: 17px;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
            }
            p {
              font-size: 15px;
              color: #666;
            }
          }
          .notice-file {
            margin: 10px 6px 0px;
            height: 40px;
            background: #ffffff;
            border-radius: 20px;
            span {
              color: #1c91ff;
              font-size: 16px;
            }
            img {
              width: 15px;
              height: 15px;
            }
          }
        }
        .earnings {
          padding: 15px 12px;
          background: #fff;
          h3 {
            font-size: 18px;
            font-family: SourceHanSansCN, SourceHanSansCN-Bold;
            font-weight: 700;
          }
          .earnings-heed {
            margin-top: 10px;
            img {
              margin-right: 10px;
              width: 30px;
              height: 30px;
            }
            p {
              padding: 15px 7px;
              color: #666666;
              font-size: 15px;
              text-align: center;
              font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            }
          }
          .earnings-content {
            margin-bottom: 30px;
            .earnings-left {
              flex: 1;
              display: flex;
              flex-direction: column;
              p {
                font-size: 14px;
                font-family: SourceHanSansCN, SourceHanSansCN-Regular;
                color: #666666;
              }
              .p-right {
                text-align: right;
              }
            }
            .earnings-right {
              flex: 1;
              height: 130px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .list-content {
          width: 100%;
          padding: 15px 20px 5px;
          background: #f7f8fa;
          border-radius: 10px;

          li {
            margin-bottom: 10px;
            font-size: 14px;
            color: #666;
            &::before {
              margin-right: 8px;
              content: '';
              display: inline-block;
              width: 6px;
              height: 6px;
              background: #26b4ff;
              border-radius: 50%;
            }
          }
        }
        .data-safety {
          padding: 15px 12px 40px;
          background: #f1f5ff;
          .data-safety-content {
            margin-top: 10px;
            padding: 10px;
            background: #ffffff;
            border-radius: 5px;
            p {
              font-size: 15px;
              color: #666666;
            }
          }
        }
      }
      .tab-flow {
        padding: 10px 12px;
        .template-download {
          margin: 0px 6px 15px;
          height: 40px;
          background: #f7f8fa;
          border-radius: 20px;
          span {
            color: #1c91ff;
            font-size: 16px;
          }
          .download {
            margin-left: 8px;
            text-decoration: underline;
          }
        }
        .flow-item {
          .flow-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            span {
              width: 22px;
              height: 22px;
              background: #26b4ff;
              border-radius: 50%;
              color: #fff;
            }
            h3 {
              font-size: 17px;
              margin-left: 13px;
            }
          }
          .flow-content-box {
            margin-left: 11px;
            padding: 15px 0px 15px 20px;
            border-left: 1px solid #eee;
            background-color: #fff;
            .flow-content {
              padding: 15px;
              background: #f7f8fa;
              color: #333;
              img {
                margin: 5px 8px 0px 0px;
                width: 14px;
                height: 14px;
              }
              .flow-content-item-time {
                margin-bottom: 15px;
                p {
                  font-size: 15px;
                }
              }
              .flow-content-item {
                display: flex;
                margin-left: 5px;
                .dot {
                  margin: 8px 13px 0px 0px;
                  width: 5px;
                  height: 5px;
                  background: #26b4ff;
                  border-radius: 50%;
                }
                p {
                  margin-bottom: 8px;
                  flex: 1;
                  font-size: 15px;
                }
              }
            }
          }
        }
      }
      .recommend {
        width: 96%;
        height: 100px;
        margin: 20px auto;
        background: #f7f8fa;
        border-radius: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .dalog-box {
        position: relative;
        width: 310px;
        background-color: #fff;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        border-radius: 10px;
        overflow: hidden;
        .dalog-content {
          padding: 24px;
          border-bottom: 1px solid #eee;
          .dalog-title {
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #333333;
            margin-bottom: 10px;
            text-align: center;
          }
          p {
            font-size: 14px;
            color: #666;
          }
        }
        .btn-box {
          color: #26b4ff;
          .btn {
            flex: 1;
            padding: 12px 0px;
          }
          .btn-gray {
            color: #323233;
            border-right: 1px solid #eee;
          }
        }
        .close-dalog {
          position: absolute;
          top: 0px;
          right: 0px;
          padding: 10px;
          .icon-close {
            font-size: 18px;
          }
        }
      }
    }
    .footer {
      padding: 10px 15px;
      background-color: #fff;
      .btn {
        height: 38px;
        border-radius: 20px;
      }
      .progressAndStatistics {
        flex: 5;
        border: 1px solid #26b4ff;
        color: #26b4ff;
      }
      .join-reported {
        margin-left: 10px;
        flex: 3;
        background-color: #26b4ff;
        color: #fff;
      }
    }
  }
</style>